import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PreFooterCallout from '../components/PreFooterCallout';

export default function Privatlivspolitik() {
  return (
    <div>
      <SEO
        title="Privatlivspolitik for Advokatfirmaet Kopp ApS"
        description="Denne privatlivspolitik forklarer, hvordan Advokatfirmaet Kopp ApS (”K§PP”) behandler personoplysninger i forbindelse med brug af hjemmeside, juridisk rådgivning og sagsbehandling."
      />

      <article className="w-full bg-white py-16 lg:py-24 px-6 lg:px-12 border-b border-slate-200">
        <div className="max-w-4xl mx-auto space-y-8 text-slate-800">
          <div>
            <Link
              to="/"
              className="inline-flex items-center space-x-2 text-xs font-semibold uppercase tracking-wider text-slate-500 hover:text-[#1c3848] mb-6"
            >
              <i className="fa-solid fa-arrow-left text-[10px]" aria-hidden="true" />
              <span>Tilbage til forsiden</span>
            </Link>
            <h1 className="text-3xl lg:text-4xl font-bold text-[#1c3848]">
              PRIVATLIVSPOLITIK FOR ADVOKATFIRMAET KOPP APS
            </h1>
          </div>

          <div className="prose prose-slate max-w-none space-y-6 text-sm leading-relaxed">
            <p>
              Denne privatlivspolitik forklarer, hvordan Advokatfirmaet Kopp ApS (”K§PP”) behandler personoplysninger i forbindelse med brug af hjemmeside, juridisk rådgivning og sagsbehandling.
            </p>
            <p>
              K§PP har tavshedspligt om langt de fleste oplysninger, herunder personoplysninger som led i sagsbehandlingen. I denne privatlivspolitik gives derfor kun udvalgt, generel information om behandling af personoplysninger.
            </p>

            <h2 className="text-xl font-bold text-[#1c3848] pt-4">Forkortelser anvendt i privatlivspolitikken</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>GDPR:</strong> Europa-Parlamentets og Rådets forordning (EU) 2016/679 af 27. april 2016 om beskyttelse af fysiske personer i forbindelse med behandling af personoplysninger og om fri udveksling af sådanne oplysninger og om ophævelse af direktiv 95/46/EF (generel forordning om databeskyttelse)
              </li>
              <li>
                <strong>DBL:</strong> Lov nr. 502 af 23. maj 2018 om supplerende bestemmelser til forordning om beskyttelse af fysiske personer i forbindelse med behandling af personoplysninger og om fri udveksling af sådanne oplysninger (databeskyttelsesloven)
              </li>
            </ul>

            <h3 className="text-lg font-semibold text-[#1c3848] pt-2">Privatlivspolitikken opdateres løbende.</h3>

            <h2 className="text-xl font-bold text-[#1c3848] pt-4">Kategorier af personoplysninger, formål og retligt grundlag</h2>
            <p>
              K§PP indsamler og behandler følgende kategorier af personoplysninger til de angivne formål med behandlingen og på de anførte juridiske grundlag:
            </p>

            <p>
              <strong>Grundlæggende principper:</strong> For at beskytte dine personoplysninger bedst muligt vurderes det, hvor høj risikoen er for, at databehandlingen påvirker dine grundlæggende rettigheder negativt. Behandlingen af personoplysninger sker på den baggrund ud fra følgende grundlæggende principper:
            </p>
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Behandlingen sker på en lovlig, rimelig og gennemsigtig måde i forhold til dig.</li>
              <li>Behandlingen er underlagt en formålsbegrænsning.</li>
              <li>Behandlingen sker ud fra et princip om dataminimering.</li>
              <li>Behandlingen sker ud fra et princip om rigtighed, der skal sikre, at de data, der behandles om dig er korrekte og ajourførte.</li>
              <li>Behandlingen sker ud fra et princip om opbevaringsbegrænsning.</li>
              <li>Behandlingen sker ud fra et princip om integritet og fortrolighed</li>
            </ul>

            <h2 className="text-xl font-bold text-[#1c3848] pt-4">Generelt om hjemmelsgrundlaget</h2>
            <p>
              Hjemmelen (retsgrundlag) for at behandle dine personoplysninger vil typisk være:
            </p>
            <p className="font-semibold text-slate-800">For almindelige personoplysninger:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Databeskyttelsesforordningens art. 6, stk. 1, a: Samtykke</li>
              <li>Databeskyttelsesforordningens art. 6, stk. 1, b: Opfyldelse af kontrakt</li>
              <li>Databeskyttelsesforordningens art. 6, stk. 1, c: Retlig forpligtelse</li>
              <li>Databeskyttelsesforordningens art. 6, stk. 1, d: Beskyttelse af dine eller andre private personers eller vitale interesser</li>
              <li>Databeskyttelsesforordningens art. 6, stk. 1, f: Interesseafvejning</li>
            </ul>

            <p className="font-semibold text-slate-800 pt-2">For særlige (personfølsomme) personoplysninger:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Databeskyttelsesforordningens art. 9, stk. 2, a: Samtykke</li>
              <li>Databeskyttelsesforordningens art. 9, stk. 2, c: Beskyttelse af dine eller andre private personers vitale interesser</li>
              <li>Databeskyttelsesforordningens art. 9, stk. 2, f: Nødvendigt for, at retskrav kan fastlægges</li>
            </ul>
            <p>
              I forbindelse med indhentelsen af dine personoplysninger vil du blive oplyst om, hvilke(n) hjemmel, der ligger til grund for behandlingen.
            </p>

            <h2 className="text-xl font-bold text-[#1c3848] pt-4">Besøgende på hjemmeside</h2>
            <p>
              Hjemmesiden anvender ikke cookies. Ved besøg på hjemmesiden registreres udelukkende almindelige tekniske data nødvendige for visning og drift af siden fx; IP-adresse, operativsystem, sprogindstilling og browsertype mv.
            </p>
            <p>
              Formålet med databehandlingen er at hente hjemmesiden fra serveren og optimere siden. Det legitime grundlag for databehandlingen er K§PPs interesse i at kunne udvikle og levere en relevant hjemmeside, som fungere optimalt, jf. artikel 6, stk. 1, litra f i Databeskyttelsesforordningen, jf. § 6, stk. 1 i Databeskyttelsesloven.
            </p>

            <h2 className="text-xl font-bold text-[#1c3848] pt-4">Sikkerhed</h2>
            <p>
              For at beskytte dig mod, at uvedkommende kan få adgang til dine personoplysninger, bruges it-løsninger, som automatisk sikrer, at al data kun er tilgængelige for relevante personer. Der anvendes ved databehandlingen procedurer, der beskytter dine data mod at blive ødelagt, tabt, ændret, offentliggjort og mod uautoriseret adgang eller deling. Det er vedtaget politikker for databehandlingen, som sikrer, at denne sker sikkert.
            </p>

            <h2 className="text-xl font-bold text-[#1c3848] pt-4">Dine rettigheder</h2>
            <ul className="list-disc pl-5 space-y-1.5">
              <li>Ret til indsigt i de personoplysninger, som behandles om dig</li>
              <li>Ret til at få ændret ukorrekte og ufuldstændige personoplysninger</li>
              <li>Ret til at få slettet personoplysninger</li>
              <li>Ret til at få begrænset behandlingen af personoplysninger</li>
              <li>Ret til dataportabilitet</li>
              <li>Ret til at gøre indsigelse mod behandling af personoplysninger</li>
              <li>Ret til at klage til Datatilsynet: www.datatilsynet.dk</li>
            </ul>

            <h2 className="text-xl font-bold text-[#1c3848] pt-4">Kontakt</h2>
            <p>
              Hvis du har spørgsmål om behandlingen af dine personoplysninger eller udnyttelsen af dine rettigheder, er du velkommen til at kontakte Advokatfirmaet Kopp ApS, Strandvejen 125, 2900 Hellerup, Danmark, CVR-nr.: 44552795, Telefonnummer: (+45) 5162 7235, e-mailadresse: gdpr@kopplaw.dk.
            </p>
          </div>
        </div>
      </article>

      <PreFooterCallout />
    </div>
  );
}
